import { gql } from '@apollo/client';

export const GET_SHARED_WITH_ME = gql`
  query sharedWithMe($limit: Int, $lastKey: String) {
    sharedWithMe(limit: $limit, lastKey: $lastKey) {
      items {
        storyId
        title
        sharers {
          username
          avatarInitials
          avatarUrl
        }
        circles
        sharedAt
        isRead
        readAt
        contributorCount
        readMinutes
        storyUrl
      }
      nextKey
      unreadCount
    }
  }
`;
